import type { PropsWithChildren } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { useCart } from "../cart/CartProvider";
import { BagIcon, UserIcon } from "./Icons";

export function Layout({ children }: PropsWithChildren) {
  const auth = useAuth();
  const { cart, message } = useCart();
  const count = cart?.items.reduce((sum, item) => sum + item.quantity, 0) ?? 0;
  const admin = auth.roles.some((role) => ["ADMIN", "CATALOG_MANAGER", "MODEL_MANAGER"].includes(role));
  return (
    <div className="app-shell">
      <header className="site-header">
        <a href="/" className="wordmark" aria-label="Atelier Yilin home"><span>ATELIER</span> YILIN</a>
        <nav className="site-header__nav" aria-label="Application navigation">
          <NavLink to="/collections">Jewelry</NavLink>
          <a href="/about/">Our story</a>
          {admin && <NavLink to="/admin/content">CMS</NavLink>}
        </nav>
        <div className="site-header__actions">
          <NavLink to="/account" aria-label="Account"><UserIcon /></NavLink>
          <NavLink to="/cart" className="bag-link" aria-label={`Shopping bag with ${count} items`}><BagIcon /><span>{count}</span></NavLink>
        </div>
      </header>
      {message && <div className="cart-toast" role="status">{message}<Link to="/cart">View bag</Link></div>}
      <main>{children}</main>
      <footer className="app-footer">
        <div><a href="/" className="wordmark"><span>ATELIER</span> YILIN</a><p>Quiet forms. Precious materials.<br />Made in Aotearoa.</p></div>
        <div><h2>Visit</h2><p>By appointment<br />Tāmaki Makaurau, Auckland</p></div>
        <div><h2>Client care</h2><a href="/help/shipping/">Shipping</a><a href="/help/care/">Jewelry care</a><a href="/help/returns/">Returns</a></div>
      </footer>
    </div>
  );
}
